/**
 * CV Settings Model
 * Stores user's CV editing preferences for hiding sections and customizing content
 */
export interface CvSettings {
  /** Sections to hide entirely (e.g., 'professionalSkills', 'languages', 'hobbies', 'aboutMe', 'dna') */
  hiddenSections: string[];

  /** IDs of individual education items to hide */
  hiddenEducations: string[];

  /** IDs of individual work experience items to hide */
  hiddenWorkExperiences: string[];

  /** IDs of individual foreign experience items to hide */
  hiddenForeignExperiences: string[];

  /** Custom "About me" text that overrides the AI-generated summary */
  editedAboutMe?: string;
}

/** Default empty CV settings */
export const defaultCvSettings: CvSettings = {
  hiddenSections: [],
  hiddenEducations: [],
  hiddenWorkExperiences: [],
  hiddenForeignExperiences: [],
  editedAboutMe: undefined
};

/** Section identifiers for CV visibility toggles */
export const CV_SECTIONS = {
  PROFESSIONAL_SKILLS: 'professionalSkills',
  LANGUAGES: 'languages',
  HOBBIES: 'hobbies',
  ABOUT_ME: 'aboutMe',
  EDUCATION: 'education',
  WORK_EXPERIENCE: 'workExperience',
  FOREIGN_EXPERIENCE: 'foreignExperience',
  DNA: 'dna'
} as const;
